module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAIAAAAVyRqTAAAAJElEQVRIx2M4J6hGI8QwavSo0aNGk2T0f5qBUaNHjR41miQAAL9jspUi+gu2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/id.png
// module id = 843
// module chunks = 0